module.exports = __webpack_public_path__ + "static/img/3.8b35832.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/aboutUs/3.png
// module id = mYGJ
// module chunks = 1